const TELEMETRY_GROUPS = [
    {
        title: "3-Phase Input",
        items: [
            { label: "Voltage R", key: "pahse_avoltage", unit: "V" },
            { label: "Voltage Y", key: "pahse_bvoltage", unit: "V" },
            { label: "Voltage B", key: "pahse_cvoltage", unit: "V" },
            { label: "Current R", key: "pahse_acurrent", unit: "A" },
            { label: "Current Y", key: "pahse_bcurrent", unit: "A" },
            { label: "Current B", key: "pahse_ccurrent", unit: "A" },
        ],
    },
    {
        title: "DC Output",
        items: [
            { label: "DC Voltage", key: "dc_voltage", unit: "V" },
            { label: "DC Current", key: "dc_current", unit: "A" },
            { label: "AC Frequency", key: "ac_frequency", unit: "Hz" },
        ],
    },
    {
        title: "Energy",
        items: [
            { label: "Cum DC Power", key: "cum_dc_power", unit: "kWh" },
            { label: "Cum AC Power", key: "cum_ac_power", unit: "kWh" },
            { label: "DC Active Power", key: "dc_active_power", unit: "kW" },
        ],
    },
];

function TelemetryRow({ label, value, unit, pulse }) {
    return (
        <div className={`rectifier-telemetry-row ${pulse ? "is-pulse" : ""}`}>
            <span className="rectifier-telemetry-row__label">{label}</span>
            <span className="rectifier-telemetry-row__value">{value ?? "—"}</span>
            <span className="rectifier-telemetry-row__unit">{unit}</span>
        </div>
    );
}

export default function RectifierTelemetryPanel({ rectifier, updateTime, pulse }) {
    return (
        <div className="rectifier-telemetry-panel">
            <div className="rectifier-telemetry-panel__meta">
                <span className="rectifier-telemetry-panel__time">
                    <i className="fa-light fa-clock me-1" />
                    {updateTime || "—"}
                </span>
                <span className="rectifier-telemetry-panel__divider">|</span>
                <span className="rectifier-telemetry-panel__live">
                    <span className="rectifier-live-dot is-live" />
                    Live
                </span>
            </div>

            <div className="rectifier-telemetry-table">
                <div className="rectifier-telemetry-table__head">
                    <span>Parameter</span>
                    <span>Value</span>
                    <span>Unit</span>
                </div>
                <div className="rectifier-telemetry-table__body">
                    {TELEMETRY_GROUPS.map((group) => (
                        <div key={group.title} className="rectifier-telemetry-section">
                            <div className="rectifier-telemetry-section__title">{group.title}</div>
                            {group.items.map((item) => (
                                <TelemetryRow
                                    key={item.key}
                                    label={item.label}
                                    value={rectifier?.[item.key]}
                                    unit={item.unit}
                                    pulse={pulse}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
